import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation();
  const navType = useNavigationType(); // 'PUSH', 'POP', 'REPLACE'

  useEffect(() => {
    // Disable native browser scroll restoration so it doesn't fight Lenis
    if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    const currentPath = location.pathname + location.search;

    // Check if we have saved restore data from clicking "Back to listings" or browser back
    let restoreData = null;
    let lastNav = null;

    try {
      const rRaw = sessionStorage.getItem('bikeeka_restore_scroll');
      if (rRaw) restoreData = JSON.parse(rRaw);
    } catch (_) {}

    try {
      const lRaw = sessionStorage.getItem('bikeeka_last_listing_nav');
      if (lRaw) lastNav = JSON.parse(lRaw);
    } catch (_) {}

    const isBackNav = navType === 'POP' || Boolean(restoreData);

    const shouldRestore = isBackNav && (
      (restoreData && (restoreData.fromPath === currentPath || location.pathname === '/')) ||
      (lastNav && (lastNav.fromPath === currentPath || location.pathname === '/'))
    );

    const targetScrollY = shouldRestore
      ? (restoreData?.scrollY ?? lastNav?.scrollY ?? 0)
      : 0;

    // Clean up one-time restore flags
    if (shouldRestore) {
      try {
        sessionStorage.removeItem('bikeeka_restore_scroll');
        sessionStorage.removeItem('bikeeka_last_listing_nav');
      } catch (_) {}
    }

    // Apply scroll smoothly and authoritatively once
    const applyScroll = () => {
      if (window.__lenis) {
        window.__lenis.scrollTo(targetScrollY, { immediate: true, force: true });
      } else {
        window.scrollTo({ top: targetScrollY, behavior: 'instant' });
      }
    };

    // Apply on animation frame after DOM is mounted
    const rafId = requestAnimationFrame(applyScroll);

    return () => {
      cancelAnimationFrame(rafId);
    };
  }, [location.pathname, location.search, navType]);

  return null;
};

export default ScrollToTop;